module.exports = __webpack_public_path__ + "fonts/manrope-extrabold.bd3a95a4.otf";